import ResyRewardsHowItWorks from './ResyRewardsHowItWorks';

export default ResyRewardsHowItWorks;
